import leftchevron from "./leftchevron.svg";
import disabledleftchevron from "./disabledleftchevron.svg";

export default function LeftChevronIcon({ disabled }) {
  return (
    <img src={disabled ? disabledleftchevron : leftchevron} />
  );
}